import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import bannerBg from '../assets/img/page-banner.jpg';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import productsData from '../components/data/products';
import BlogThreeItem from '../components/Blog3/BlogThreeItem';
import ProductSidebar from '../components/ProductSidebar';
import BlogThreeItemFour from '../components/Blog3/BlogThreeItemFour';

function ProductCategory() {
    const { category } = useParams();
    const location = useLocation();

    useEffect(() => {
        const element = document.getElementById('product-category-title');
        if (element) {
            // Use a small delay to ensure the content has rendered and layout is stable
            const scrollTimeout = setTimeout(() => {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }, 100);
            return () => clearTimeout(scrollTimeout);
        }
    }, [category, location.hash]);

    // Filter products for the current category
    const categoryProducts = productsData.filter(
        (product) => product.category.toLowerCase() === category?.toLowerCase()
    );
console.log(categoryProducts);
    return (
      <>
        <Header1 />
        {/* <PageBanner 
                bannerBg={bannerBg} 
                currentPage={category} 
                heading={`${category} Products`} 
            /> */}

        <section className="blog-wrapper section-padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-4 mt-5 mb-5 mt-md-0 col-12 order-1 order-md-1">
                <ProductSidebar activeCategory={category} />
              </div>
              <div className="col-lg-9 col-md-8 col-12 order-2 order-md-2 mb-5">
                <h1
                  id="product-category-title"
                  style={{
                    textTransform: "capitalize",
                    marginTop: "-7px",
                    textAlign: "left",
                    scrollMarginTop: "120px", // Offset for sticky header
                  }}
                >
                  {category.replace(/-/g, " ")}
                </h1>
                <div className="row">
                  {categoryProducts.length > 0 ? (
                    categoryProducts.map((data) => (
                      <BlogThreeItemFour
                        key={data.id}
                        thumb={data.thumbnail}
                        img={data.Image}
                        title={data.title}
                        // author={data.author || 'Admin'}
                        // meta={data.meta || '2024'}
                        category={data.category}
                        slug={data.slug}
                      />
                    ))
                  ) : (
                    <div className="col-12 text-center">
                      <h3>No products found in this category.</h3>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer1 />
      </>
    );
}

export default ProductCategory;
